import { combineReducers } from 'redux';
import stickerPacksReducer from './stickerPacksSlice';
import stickersReducer from './stickersSlice';
import usersReducer from './usersSlice';
import assetsReducer from './assetsSlice';
import categoriesReducer from './categoriesSlice';
import reportsReducer from './reportsSlice';

export default combineReducers({
  stickerPacks: stickerPacksReducer,
  users: usersReducer,
  stickers: stickersReducer,
  assets: assetsReducer,
  categories: categoriesReducer,
  reports: reportsReducer,
})
